<script setup>
import { Head } from '@inertiajs/inertia-vue3';
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue';
import AppLayout from '@/Layouts/AppLayout.vue'

defineProps({
    policy: String,
});
</script>

<script>
export default {
    mounted(){
        document.querySelector('section.page-header').style.background = 'url("' + this.asset('/images/backgrounds/background-image-3.jpg') + '")';
        document.querySelector('section.page-header').style.backgroundRepeat = 'no-repeat';
        document.querySelector('section.page-header').style.backgroundSize = 'cover';
        document.querySelector('section.page-header').style.backgroundPosition = 'center';
    }
}
</script>

<template>
    <AppLayout title="Partners" desc="Discovers a wide range of properties in Dubai and UAE with Inspire Properties">
        <template #header>
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="javascript:void(0);">Company</a></li>
                </ol>
            </nav>
            <div>
                <h2 class="page-header-heading">Partners</h2>
            </div>
        </template>

        <section class="partners">
            <div class="container">
                <div class="row">
                    <div class="col-lg-3 col-6 mb-2">
                       <div class="partner-card">
                          <figure>
                              <img :src="asset('/images/partner/cam.png')">
                          </figure>
                       </div>
                    </div>
                     <div class="col-lg-3 col-6  mb-2">
                        <div class="partner-card">
                          <figure>
                              <img :src="asset('/images/partner/avaitation.png')">
                          </figure>
                       </div>
                    </div>
                     <div class="col-lg-3 col-6  mb-2">
                        <div class="partner-card">
                          <figure>
                              <img :src="asset('/images/partner/damlawpng.png')">
                          </figure>
                       </div>
                    </div>
                    <div class="col-lg-3 col-6  mb-2">
                        <div class="partner-card">
                          <figure>
                              <img :src="asset('/images/partner/SALIDA-DEL-SOL-logo.png')">
                          </figure>
                       </div>
                    </div>
                     <div class="col-lg-3 col-6  mb-2">
                       <div class="partner-card">
                          <figure>
                              <img :src="asset('/images/partner/cam.png')">
                          </figure>
                       </div>
                    </div>
                     <div class="col-lg-3 col-6  mb-2">
                        <div class="partner-card">
                          <figure>
                              <img :src="asset('/images/partner/avaitation.png')">
                          </figure>
                       </div>
                    </div>
                     <div class="col-lg-3 col-6 mb-2">
                        <div class="partner-card">
                          <figure>
                              <img :src="asset('/images/partner/damlawpng.png')">
                          </figure>
                       </div>
                    </div>
                    <div class="col-lg-3 col-6  mb-2">
                        <div class="partner-card">
                          <figure>
                              <img :src="asset('/images/partner/SALIDA-DEL-SOL-logo.png')">
                          </figure>
                       </div>
                    </div>
                    
                </div>   
            </div>
        </section>
    </AppLayout>
</template>
